import { ToastContainer } from 'react-toastify';

// wrapper around notification container implementation
export const NotificationContainer = () => {
  return (
    <ToastContainer
      newestOnTop
      pauseOnHover
      hideProgressBar
      autoClose={5000}
      progressClassName="notification-progress-bar"
    />
  );
};
